import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export const usePortfolioTitle = (
	portfolio: PortfolioDetailResponseDTO | undefined,
	t: (text: string) => string,
) => {
	if (!portfolio) return "";

	const title =
		portfolio.name ??
		[
			portfolio.product,
			portfolio.contractNumber && `(${portfolio.contractNumber})`,
		]
			.filter(Boolean)
			.join(" ");

	if (title) {
		if (title.startsWith("(") && title.endsWith(")")) {
			return title.slice(1, -1);
		}

		return title;
	}

	return portfolio.domain
		? t(Resources.Portfolio.List.PortfolioDomainType[portfolio.domain])
		: "";
};
